import { GeoPoint } from 'firebase/firestore';
import { atom } from 'recoil';

import { emptyOperatingTime } from '~/types/utilities';

import { Store } from '~/types/store/store';

type StoreInfo = Pick<
  Store,
  | 'name'
  | 'image'
  | 'banners'
  | 'logo'
  | 'location'
  | 'description'
  | 'operatingTime'
  | 'preOrderSetting'
> & { id: string, officialHoliday: Array<Date> };

const storeInfo = atom<StoreInfo>({
  key: 'storeInfo',
  default: {
    id: '',
    name: '',
    image: '',
    logo: '',
    description: '',
    operatingTime: emptyOperatingTime,
    preOrderSetting: {
      afterHours: 1,
      beforeHours: 720,
      schedule: emptyOperatingTime,
    },
    banners: [],
    location: {
      address: '',
      geoPoint: new GeoPoint(0, 0),
    },
    officialHoliday: [],
  },
});

export default storeInfo;
